import { makeAutoObservable, runInAction } from 'mobx'
import get from 'lodash/get'
import feelGreateAPI from 'GlobalStores/FeelGreat/APIs'
import { ObjectHelpers } from 'Helpers/ObjectHelpers'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import Customer from 'GlobalStores/User/Customer'

class StoreReferral {
    referralData = null
    referralCode = ''
    loadingReferCode = false
    currentReferralData = null
    errorMessage = ''
    errorLength = ''
    qsReferral = ''

    instance = null

    constructor() {
        makeAutoObservable(this)
    }
    /**
     * @returns {Customer} Customer
     */
    Customer() {
        if (!this.instance) {
            this.instance = new Customer(this.referralData)
        }
        return this.instance
    }

    SetReferralData(userRef, status) {
        runInAction(() => {
            this.referralData = {
                ...this.referralData,
                ...userRef,
                shortStatus: status
            }
        })
    }

    async GetReferralCode(token) {
        try {
            let response = await feelGreateAPI.getReferralCodes(token)
            this.referralCode = get(response, 'data.items[0].referralCode', '')
            this.referralData = get(response, 'data.items[0]', {})
            setTimeout(() => {
                this.loadingReferCode = false
            }, 1000)
        } catch (error) {
            console.log('getReferralCode error => ', error)
            setTimeout(() => {
                this.loadingReferCode = false
            }, 1000)
        }
    }

    UsePrice() {
        if (StoreAuth.GetId()) {
            return 'after'
        } else if (get(this.referralData, 'id.unicity', '').length > 0) {
            return 'after'
        } else {
            return 'retail'
        }
    }

    GetReferral() {
        return this.referralData
    }

    HasReferral() {
        const id = get(this.referralData, 'baId', '')
        return id && !ObjectHelpers.isEmpty(this.referralData.displayName) ? id : false
    }

    reset() {
        this.referralData = null
        this.instance = null
    }

    DisplayName() {
        return get(this.referralData, 'displayName', null)
    }
}
const storeReferral = new StoreReferral()
export default storeReferral
